import { FormControl, UntypedFormGroup } from '@angular/forms';
import { IpsPersonalDetailsForm } from '../../models/appliance-details-stepped/ips-personal-details-form.interface';
import { PersonalDetailsFormField } from '../../models/appliance-details-stepped/personal-details-form-field.enum';

export const mockIpsPersonalDetailsForm: IpsPersonalDetailsForm = {
  [PersonalDetailsFormField.IpsAddress]: new UntypedFormGroup({
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    city: new FormControl(),
    countryCode: new FormControl(),
    externalAVSAddressId: new FormControl(),
    isFormatted: new FormControl(),
    overrideAddress: new FormControl(),
    postalCode: new FormControl(),
    regionOrStateCode: new FormControl(),
  }),
  [PersonalDetailsFormField.EmailAddress]: new FormControl(null),
  [PersonalDetailsFormField.FirstName]: new FormControl(null),
  [PersonalDetailsFormField.LastName]: new FormControl(null),
  [PersonalDetailsFormField.PrivacyPolicy]: new FormControl(true, {
    nonNullable: true,
  }),
  [PersonalDetailsFormField.TelephoneNumber]: new FormControl(null),
};
